import React, { useState, useMemo } from 'react';
import Label from '../../components/common/Label';
import Input from '../../components/common/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import ValidationIcon from '../../components/common/ValidateIcon';
import { doPasswordsMatch } from '../../utils/passwordUtils';

const ConfirmPasswordInput = ({ password, confirmPassword, handleConfirmPasswordChange }) => {
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const showPasswordsMatch = Boolean(password);

  const passwordsMatch = useMemo(() => {
    return doPasswordsMatch(password, confirmPassword);
  }, [password, confirmPassword]);

  const validationTextColorClass = passwordsMatch ? 'text-custom-success-color' : 'text-gray-500';

  return (
    <>
      <div className="relative min-h-[2rem] mt-6">
        <Label variant="dark" htmlFor="confirm-password" customClass="block text-sm font-normal">
          Confirm New Password
        </Label>
        <Input
          variant="tertiary"
          type={confirmPasswordVisible ? 'text' : 'password'}
          id="confirm-password"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          placeholder="Enter your Password"
          ariaLabel="Password input field"
          ariaDescribedby="password-error"
        />
        <button
          type="button"
          onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
          aria-label={
            confirmPasswordVisible ? 'Hide Confirmation password' : 'Show Confirmation password'
          }
          className="absolute right-3 bottom-2 bg-none border-none cursor-pointer w-auto"
        >
          <FontAwesomeIcon
            icon={confirmPasswordVisible ? faEyeSlash : faEye}
            className="text-lg text-gray-500"
          />
        </button>
      </div>
      {showPasswordsMatch && (
        <p className={`flex items-center mt-2 text-[15px] ${validationTextColorClass}`}>
          <span className="flex items-center mr-2">
            <ValidationIcon isValid={passwordsMatch} />
          </span>
          Passwords match successfully.
        </p>
      )}
    </>
  );
};

export default ConfirmPasswordInput;
